module.exports = __webpack_public_path__ + "static/media/BobNostalgic.ffe114fd.jpg";